import { TabsHost } from './host';
import { TabsScreen } from './screen';
export const Tabs = {
  Host: TabsHost,
  Screen: TabsScreen
};
//# sourceMappingURL=index.js.map